import { Component, forwardRef, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { ExternalSelectorComponent } from '../../external-selector/external-selector.component';
import { GruppiRamiComponent } from 'src/app/admin/gruppi-rami/gruppi-rami.component';

@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => GruppoRamiPickerComponent) },
  ],
  selector: 'gruppo-rami-picker',
  templateUrl: '../../external-selector/external-selector.component.html',
  styleUrls: ['../../external-selector/external-selector.component.scss']
})
export class GruppoRamiPickerComponent extends ExternalSelectorComponent {

  @Input()
  get externalEntityObserver(): Observable<any> {
    return this.dialog.open(GruppiRamiComponent, { data: { selectionMode: true } }).afterClosed();
  };


}
